export function setlistSlug(title: string) {
  const slug = title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('it-IT')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 64);
  return slug || 'scaletta';
}

export function buildInviteUrl(origin: string, setlistTitle: string, token: string) {
  const url = new URL(`/invito/${setlistSlug(setlistTitle)}`, origin);
  url.searchParams.set('token', token);
  return url;
}

export function inviteTokenFromLocation(location: Pick<Location, 'search' | 'pathname'>) {
  const params = new URLSearchParams(location.search);
  const token = params.get('token') ?? params.get('invite');
  if (!token) return null;
  if (params.has('invite')) return token;
  return location.pathname.startsWith('/invito/') ? token : null;
}

export function inviteTokenFromText(value: string) {
  const input = value.trim();
  if (/^[a-f0-9]{64}$/i.test(input)) return input;
  try {
    const url = new URL(input);
    const token = inviteTokenFromLocation(url);
    return token && /^[a-f0-9]{64}$/i.test(token) ? token : null;
  } catch {
    return null;
  }
}

export function inviteShareText(setlistTitle: string) {
  return [
    `Ti invito a collaborare alla scaletta “${setlistTitle}”.`,
    'Apri il link, inserisci il tuo numero e lo strumento che suoni.',
  ].join('\n');
}
